"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
const provider_1 = require("../../../provider/provider");
const AutoAIAgentModal_vue_1 = __importDefault(require("../autoAIAgent/AutoAIAgentModal.vue"));
const AutoAIModal_vue_1 = __importDefault(require("./AutoAIModal.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AutoAIView',
    setup(__props) {
        const presenter = (0, vue_3.inject)(provider_1.autoAIPresenterInjectKey);
        const agentPresenter = (0, vue_3.inject)(provider_1.autoAIAgentPresenterInjectKey);
        function handleUsePrompt({ prompt, provider }) {
            agentPresenter?.close();
            presenter?.setIntructions(prompt);
            presenter?.setProvider(provider);
            presenter?.showShiftGenerator();
            presenter?.setIsVisible(true);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createVNode)(AutoAIModal_vue_1.default),
                (0, vue_2.createVNode)(AutoAIAgentModal_vue_1.default, { onUsePrompt: handleUsePrompt })
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
